var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    ref: "trigger",
    staticClass: "tooltip",
    on: {
      "mouseover": _vm.onTriggerMouseEnter,
      "mouseleave": _vm.onTriggerMouseLeave
    }
  }, [_c('v-icon', {
    staticClass: "info-icon",
    class: {
      'disabled': _vm.disabled
    },
    attrs: {
      "color": _vm.color ? _vm.color : '#ccc200'
    }
  }, [_vm._v(_vm._s(_vm.icon ? _vm.icon : 'mdi-information'))])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }